import { useVersaoDaApi } from '../api/queries.js';

const TEXTOS = {
  'pre-producao': 'PRÉ-PRODUÇÃO · dados de cópia',
  desenvolvimento: 'DESENVOLVIMENTO',
} as const;

/**
 * Diz em que ambiente a pessoa está, quando não é a produção.
 *
 * Desde 19/10/2026 existem dois ambientes com dados quase iguais: o
 * pré-produção é uma cópia da produção daquela data. Numa aba há 8 Malbec, na
 * outra 9 — e nada na tela dizia qual era qual. Mexer num achando que é o outro
 * é o erro mais fácil de cometer e o mais difícil de perceber depois.
 *
 * O ambiente vem da API, não do build: a mesma imagem precisa poder rodar nos
 * dois lugares, e um rótulo assado no bundle obrigaria a construir uma imagem
 * por ambiente — o que é justamente o que se quer parar de fazer.
 *
 * Montada fora do portão de login, ao lado do App: é ANTES de entrar que mais
 * importa saber onde se está. Pílula pequena no topo, sem empurrar o layout e
 * sem capturar toque — ela informa, não atrapalha.
 */
export function FaixaDeAmbiente() {
  const { data } = useVersaoDaApi();
  const ambiente = data?.ambiente;

  if (!ambiente || ambiente === 'producao') return null;

  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 top-0 z-50 flex justify-center pt-[env(safe-area-inset-top)]"
    >
      <span className="rounded-b-lg bg-amber-400 px-3 py-0.5 text-[11px] font-bold tracking-wide text-black shadow">
        {TEXTOS[ambiente]}
      </span>
    </div>
  );
}
